import React from "react";
import "./style.scss";
import PropTypes from "prop-types";

const InfoBlock = ({ children }) => {
  return (
    <div className="info-block">
      <div className="content-container">{children}</div>
    </div>
  );
};

InfoBlock.propTypes = {
  children: PropTypes.any
};

export default InfoBlock;
